/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ orgName: NonNullable<unknown> }} Org_Suspended_Body_NamedInputs */



/**
* | output |
* | --- |
* | "Access to {orgName} has been paused. Your data has not been deleted and will be available again once the suspension is lifted." |
*
* @param {Org_Suspended_Body_NamedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const org_suspended_body_named = /** @type {((inputs: Org_Suspended_Body_NamedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Org_Suspended_Body_NamedInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Der Zugriff auf ${i?.orgName} wurde ausgesetzt. Ihre Daten wurden nicht gelöscht und stehen wieder zur Verfügung, sobald die Sperre aufgehoben wird.`)
	return /** @type {LocalizedString} */ (`Access to ${i?.orgName} has been paused. Your data has not been deleted and will be available again once the suspension is lifted.`)
});